module.exports = __webpack_public_path__ + "static/img/wood71.f757294.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood71.jpg
// module id = 5xpT
// module chunks = 0